import iconTime from "../../assets/icon_time.svg";
import iconNobrandMap from "../../assets/icon_nobrand_map.svg";
import InputBox from "../../components/InputBox/InputBox";
import useSelectBranch from "#features/SelectBranch/hooks/useSelectBranch";
import NaverMap from "../../features/Map/components/NaverMap";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { IoIosArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import useIOSVersion from "../../hooks/useIOSVersion";
import useReactGASend from "#src/hooks/useReactGASend.js";

const SelectBranch = ({
  keyword,
  handleInputChange,
  handleClearClick,
  search,
}) => {
  return (
    <div>
      <h2 className="text-3xl font-semibold mb-2.5">점포를 설정해 주세요</h2>
      <InputBox
        keyword={keyword}
        handleInputChange={handleInputChange}
        handleClearClick={handleClearClick}
        search={search}
      />
    </div>
  );
};

const BranchList = ({
  keyword,
  branch,
  branchList,
  selectBranch,
  ChagneDistance,
}) => {
  const listRef = useRef(null);
  const itemRefs = useRef([]);

  useEffect(() => {
    if (branch?.id && itemRefs.current[branch.id]) {
      itemRefs.current[branch.id].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [branch]);

  return (
    <div ref={listRef} className="flex-1 overflow-y-auto">
      {keyword !== (null || "") && (
        <>
          {branchList?.length > 0 ? (
            <ul>
              {branchList?.map(
                ({ id, name, address, jobType, openTime, distance }) => (
                  <li
                    key={id}
                    ref={(el) => (itemRefs.current[id] = el)}
                    className={`flex flex-col gap-1 p-3 rounded-[10px] ${
                      id === branch.id ? "bg-neutral-100" : "bg-white"
                    }`}
                    onClick={() => selectBranch(id)}
                  >
                    <h3 className="text-lg font-semibold">{name}</h3>
                    <p className="font-medium text-neutral-500">{address}</p>
                    <div className="flex justify-between">
                      <p className="flex items-center gap-1 font-semibold">
                        {jobType === "OP"
                          ? "영업중"
                          : jobType === "PR"
                            ? "영업준비중"
                            : jobType === "CL"
                              ? "영업종료"
                              : "휴점일"}
                        {openTime && (
                          <>
                            <img src={iconTime} alt="" /> {openTime}
                          </>
                        )}
                      </p>
                      {distance && (
                        <p className="text-lg font-semibold">
                          {ChagneDistance(distance)}
                        </p>
                      )}
                    </div>
                  </li>
                )
              )}
            </ul>
          ) : (
            <p className="flex items-center justify-center h-full py-10 font-medium">
              검색 결과가 없습니다.
            </p>
          )}
        </>
      )}
    </div>
  );
};

const ExternalLinkOpener = ({ href, onOpened }) => {
  const linkRef = useRef(null);

  useEffect(() => {
    if (href && linkRef.current) {
      linkRef.current.click();
      onOpened?.();
    }
  }, [href, onOpened]);

  if (!href) return null;

  return (
    <a
      ref={linkRef}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      tabIndex={-1}
      aria-hidden="true"
      className="sr-only"
    />
  );
};

const SelectBranchWithMapPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const { isIOS14OrAbove } = useIOSVersion();
  const navigate = useNavigate();
  const ChagneDistance = (kmeter) => {
    let parsedMeter = parseInt(kmeter || '0');
    return `${parsedMeter <= 0 ? parsedMeter : parsedMeter.toFixed(1)}km`;
  };

  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const brandName = useSelector((state) => state.checkArsStatus.brandName);
  const [color, setColor] = useState("yellow-c-nobrand");

  
  useEffect(() => {
    switch (brandId) {
      case "ED":
        setColor("yellow-c-everyday");
        break;

      default:
        setColor("yellow-c-nobrand");
    }
  }, [brandId]);
  

  const trackLinkClick = () => {
    makeEventTrackFn({
      category: "event",
      action: `${brandName}점포선택`,
    });
  };

  const {
    keyword,
    search,
    handleInputChange,
    handleClearClick,
    selectBranch,
    moveToDestination,
    branch,
    setKeyword,
    location,
    setLocation,
    branchListWithDistance,
    pendingExternalUrl,
    clearPendingExternalUrl,
  } = useSelectBranch();

  const handleBranchClick = () => {
    trackLinkClick();

    if (branch?.id) {
      moveToDestination(branch.id);
    }
  }

  return (
    <section
      className={`flex flex-col gap-2 p-4 py-2 ${
        isIOS14OrAbove ? "absolute top-0 left-0 right-0 bottom-0" : "h-dvh"
      }`}
    >
      <ExternalLinkOpener
        href={pendingExternalUrl}
        onOpened={clearPendingExternalUrl}
      />
      <SelectBranch
        keyword={keyword}
        handleInputChange={handleInputChange}
        handleClearClick={handleClearClick}
        search={search}
      />
      <BranchList
        keyword={keyword}
        branch={branch}
        branchList={branchListWithDistance}
        selectBranch={selectBranch}
        ChagneDistance={ChagneDistance}
      />
      <NaverMap
        brandId={brandId}
        selectBranch={selectBranch}
        branch={branch}
        branchList={branchListWithDistance}
        setKeyword={setKeyword}
        location={location}
        setLocation={setLocation}
      />

      {branch ? (
        <button
          className={`flex justify-between items-center bg-${color} rounded-[20px] py-3.5 px-10 h-[4.625rem]`}
          onClick={handleBranchClick}
        >
          <div>
            <img src={iconNobrandMap} alt="" />
          </div>
          <div className="text-xl font-semibold">선택완료</div>
        </button>
      ) : (
        <button
          className="flex justify-between items-center bg-neutral-200 rounded-[20px] py-3.5 px-10 h-[4.625rem]"
          onClick={() => navigate(-1)}
        >
          <div>
            <IoIosArrowRoundBack className="text-5xl" />
          </div>
          <div className="text-xl font-semibold">이전으로</div>
        </button>
      )}
    </section>
  );
};

export default SelectBranchWithMapPage;
